import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  title: {
    color: 'black',
    fontSize: 18,
    fontWeight: 'bold',

    [theme.breakpoints.up('sm')]: {
      fontSize: 24,
      marginBottom: theme.spacing(1),
    },
  },
}))

export default function Title({ children }) {
  const classes = useStyles()

  return (
    <Typography variant="h5" className={classes.title}>
      {children}
    </Typography>
  )
}
